import React, { useState, useEffect } from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import PostSection from "./Sections/PostSection";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useParams } from 'react-router-dom'
import API from '../../api/api';

const garageApi = new API();

export default function NewsOnePage(props) {
  const { configuration } = props;
  const { id } = useParams();
  const [snackBar, setSnackBar] = useState(false);
  const [post, setPost] = useState({});
  const [loadingPost, setLoadingPost] = useState(false);

  useEffect(() => {

    garageApi.openEndpoints.posts.getOne( { id: id } )
      .then((postGET) => {
        try
        {
          setPost(postGET.data[0]);
          setLoadingPost(true);
        }
        catch(e)
        {
          setSnackBar(true);
        }

      });
   // eslint-disable-next-line
  }, []);

  function closeSnackBar (event, reason)
  {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBar(false);
  }


  return (
    <PageLayout configuration={configuration} title={loadingPost && post && post.title ? post.title : 'Nachrichten'}>
      <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning" >Server Fehler 500</MuiAlert>
      </Snackbar>
      <PostSection data={post} loadingPost={loadingPost}  />
    </PageLayout>
  );
}
